import { render } from "./Bar.vue?vue&type=template&id=532103c8&scoped=true"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"

import "./Bar.vue?vue&type=style&index=0&id=532103c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532103c8"]])

export default __exports__